import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  contactUsData: {},
  error: "",
  success: false,
  status: "",
};

const contactUsCall = createAsyncThunk("post/contact-us", async ({ data }) => {
  try {
    const result = await axios.post(
      `${process.env.REACT_APP_CMS_URL}/contact-uses?populate=*`,
      data
    );

    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const contactUsSlice = createSlice({
  name: "contact-us",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(contactUsCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(contactUsCall.fulfilled, (state, action) => {
      // console.log(action.payload, "Feedback Action");
      state.loading = false;
      state.contactUsData = action?.payload?.status?.success;
      state.success = action?.payload?.status?.success;
      state.error = "";
    });
    builder.addCase(contactUsCall.rejected, (state, action) => {
      state.loading = false;
      state.contactUsData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default contactUsSlice.reducer;
export const { reset } = contactUsSlice.actions;
export { contactUsCall };
